import React, { useEffect, useState }  from 'react';
import PropTypes from "prop-types";
import axios from "axios";
import Swal from 'sweetalert2'
import { useFormik } from 'formik';
import * as yup from 'yup';
import { MenuItem, TextField } from '@mui/material';
import Modal from 'react-bootstrap/Modal';

const validationSchema = yup.object({
    questionTypeId: yup.string().required('Question Type is required'),
    name: yup.string('Enter your name').required('Name is required')
    .test('no-extra-space', 'Invalid spacing', value => {
        if (!value) return true;
        return normalizeString(value) === value;
    })
});

const normalizeString = (value) => {
    if (!value) return '';
    return value
        .trim()                 // start/end spaces remove
        .replace(/\s+/g, ' ');  // multiple spaces → single space
};

export const EditQuestion = ({showQuestion, setShowQuestion, handleQuestionClose, getList, editQuestionId, setEditQuestionId, ...rest}) => { 
    const handleClose = () => setShowQuestion(false);
    const [questionTypes, setQuestionTypes] = useState([]);
    
    const initialValues = {
        id: editQuestionId,
        questionTypeId: '',
        name: '',
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
        }
    });
  
    useEffect(() => {
        if(editQuestionId > 0){
            getQuestionTypes();
            axios.get(`api/question?id=${editQuestionId}`).then(async (res) => {
                if(res.data.success){
                    formik.setFieldValue('id', res.data.data.id)
                    formik.setFieldValue('name', res.data.data.name)
                    formik.setFieldValue('questionTypeId', res.data.data.questionTypeId)
                }
            })
        }
        else{
            formik.setFieldValue('id', 0)
            formik.setFieldValue('name', '')
            formik.setFieldValue('questionTypeId', '')
        }
    },[showQuestion]);

    const getQuestionTypes = async() => {
        await axios.get('/api/questions/types')
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setQuestionTypes(result.data)
            }
            else {
                // setIsError(true);
            }
        })
    }

    const handleSubmit = (values) =>{
        if(editQuestionId > 0){
            console.log(values);
            const cleanedValues = {
                ...values,
                name: normalizeString(values.name)
            };
            axios.put(`api/questions/update`, cleanedValues).then(res => {
                if(res.data.success){
                    setShowQuestion(false);                    
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        getList();                        
                    })
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                setShowQuestion(false)
                // console.log(error.response.data)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }
        else{
            axios.post(`api/questions/create`, values).then(res => {
                if(res.data.success){
                    setShowQuestion(false);
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        getList();
                    })                
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                setShowQuestion(false)
                // console.log(error.response.data)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }        
    }
    const handlePopupClose = () => {
        formik.resetForm();
        handleClose()
    }

    const handleNameChange = (e) => {
        const cleanedValue = normalizeString(e.target.value);
        formik.setFieldValue('name', cleanedValue);
    };

    const handleNameBlur = (e) => {
        const cleanedValue = normalizeString(e.target.value);
        formik.setFieldValue('name', cleanedValue);
        formik.handleBlur(e);
    };

    return (
        <Modal show={showQuestion} onHide={handlePopupClose}>
            <Modal.Header closeButton>
            <Modal.Title>Edit Question</Modal.Title>
            </Modal.Header>
                <form onSubmit={formik.handleSubmit}>
                    <Modal.Body>                        
                        <div className="mb-3">
                            <label className="form-label" htmlFor="basic-icon-default-email">Question</label>
                            <div className="input-group input-group-merge">
                                <input type="text" className="form-control" id="basic-icon-default-firstname" placeholder="Comes to work on time, every time" aria-label="Question" aria-describedby="basic-icon-default-fullname2" 
                                name="name" 
                                value={formik.values.name} 
                                onChange={formik.handleChange}
                                onBlur={handleNameBlur}
                                />
                            </div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="defaultSelect" className="form-label">Question Type</label>
                            {/* <select id="defaultSelect" className="form-select">
                                <option>Please Select</option>
                                <option value="1">Rating</option>
                                <option value="2">Free Text</option>
                                <option value="3">Single Choice</option>
                                <option value="4">Multiple Choice</option>
                            </select> */}
                            <TextField fullWidth select
                                size='small'
                                label='Question Type'
                                id='questionTypeId'
                                value={formik.values.questionTypeId}
                                onChange={(e) => formik.setFieldValue('questionTypeId', e.target.value)}
                                error={formik.touched.questionTypeId && Boolean(formik.errors.questionTypeId)}
                                helperText={formik.touched.questionTypeId && formik.errors.questionTypeId}
                            >
                                <MenuItem value={""}>Please Select</MenuItem>
                                {
                                    questionTypes.length > 0 ? 
                                    questionTypes.map(questionType => (
                                        <MenuItem key={questionType.id} value={questionType.id}>{questionType.name}</MenuItem>
                                    ))
                                    : ''
                                }
                            </TextField>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" onClick={handlePopupClose}>Close</button>
                        <button type="submit" className="btn btn-primary">Update</button>
                    </Modal.Footer>
                </form>
        </Modal>
    )
}
export default EditQuestion;
EditQuestion.propTypes = {
    showQuestion: PropTypes.bool.isRequired,
    setShowQuestion: PropTypes.func.isRequired,
    // handleQuestionClose: PropTypes.func.isRequired    
};